import { render, staticRenderFns } from "./event-view-page.vue?vue&type=template&id=cdc9fd86&"
import script from "./event-view-page.vue?vue&type=script&lang=js&"
export * from "./event-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports